import {Box, Stack, Typography} from "@mui/material";
import {ProjectWithPreview} from "../ProjectWithPreview";
import {BackButton} from "../BackButton";
import {CustomChip} from "../CustomChip";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";

const CVApp = () => (
    <ProjectWithPreview projectUrl={"https://cristian.hilohi.dev/"}>
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            padding: 3,
            height: '100%',
            justifyContent: 'space-between'
        }}>
            {/* Project Title */}
            <Box sx={{gap: 3, display: 'flex', flexDirection: 'column'}}>
                <Typography variant="h3" sx={{fontWeight: 600, mb: 1}}>
                    Personal website / CV App
                </Typography>
                <Typography variant="h6" sx={{color: 'text.secondary'}}>
                    Current website you are seeing. App for presenting my professional achievements
                </Typography>

                {/* Overview */}
                <Box>
                    <Typography variant="h5" sx={{color: 'secondary.main', mb: 1, fontWeight: 500}}>
                        Overview
                    </Typography>
                    <Typography variant="body1" sx={{lineHeight: 1.7, whiteSpace: 'pre-line'}}>
                        This is a static website made in React with typescript.{'\n'}
                        This website was created to serve as a virtual business card and to provide a customizable
                        interface for showcasing the projects I’ve worked on.
                    </Typography>
                </Box>

                {/* Tech summary */}
                <Box>
                    <Typography variant="h5" sx={{color: 'secondary.main', mb: 1.5, fontWeight: 500}}>
                        Technologies
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <CustomChip text={'React'} variant={'primary'}/>
                    </Stack>
                </Box>

                {/* Tools summary */}
                <Box>
                    <Typography variant="h5" sx={{color: 'secondary.main', mb: 1.5, fontWeight: 500}}>
                        Tools
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <CustomChip text={'Github'} variant={'secondary'}/>
                        <CustomChip text={'Render.com'} variant={'secondary'}/>
                        <CustomChip text={'Namecheap.com'} variant={'secondary'}/>
                        <CustomChip text={'Zoho Mail'} variant={'secondary'}/>
                        <CustomChip text={'Adobe Photoshop'} variant={'secondary'}/>
                    </Stack>
                </Box>

                <Typography variant="body1" sx={{
                    lineHeight: 1.7,
                    whiteSpace: 'pre-line',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                }}>
                    <InfoOutlineIcon/>
                    I also figured it would be funny to keep the presentation template and show the website on the
                    right. Let's see how many times you can mirror this page 😁
                </Typography>


            </Box>

            <Box>
                <BackButton/>
            </Box>
        </Box>
    </ProjectWithPreview>
)

export default CVApp;